import React, { useMemo } from "react";
import GenericChart from "../GenericChart";
import MultiFeatureCard from "../../../../../components/Common/Card/MultiOptionsCard/MultiFeatureCard";
import { get } from "lodash";
import { useSelector } from "react-redux";
import useFetchAiAnalyticsWidgetData from "../../../hooks/useFetchAiAnalyticsWidgetData";

const SentimentDistribution = (props) => {
  const { itemData, timeperiodLabel } = props

  const { applied_filter_values } = useSelector(e => e.filterReducer);

  const { data, isLoading } = useFetchAiAnalyticsWidgetData({
    widgetId: "ai_analytics_sentiment_distribution",
    appliedFilterValues: applied_filter_values,
    "widget_config": {},
  })

  const { seriesData, categories } = useMemo(() => {
    if (!data) return { seriesData: [], categories: [] };
    let cat = [];
    let seriesData = [];
    get(data, 'columns', []).forEach((item, index) => {
      const category = get(itemData, "keysConfigMap", {})[item];
      cat.push(category);
      seriesData.push({
        y: get(data, 'metric_data', [])[0]?.[index],
        color: itemData.color_map[category]
      });
    });
    return { seriesData: [{ name: get(itemData, 'title', ''), data: seriesData }], categories: cat };
  }, [data]);

  return (
    <MultiFeatureCard
      title={get(itemData, 'title', '')}
      subTitle={get(itemData, 'subTitle', '') + " " + timeperiodLabel}
      loading={isLoading}
      isNoData={!get(seriesData, "[0].data.length", 0) && !isLoading}
      renderContent={() => {
        return (
          <GenericChart
            defaultConfig={get(itemData, 'chartDefaultConfig', {})}
            xAxisCategories={categories}
            series={seriesData}
            tooltipValueKeysConfig={{
              isheaderVisible: false,
              headerLabelKey: "",
              bodyLabelKey: "category",
              bodyValueKey: "y"
            }
            }
          />
        )
      }}
    />
  )
}
export default SentimentDistribution